module.exports = __webpack_public_path__ + "static/media/iconmonstr-delivery-6.51d8ea80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-delivery-6.svg
// module id = 722
// module chunks = 0